import { fetchInstagramReelMedia, type InstagramReelResponse } from './api';

// Cache map to store video URLs by post code
const reelCache = new Map<string, InstagramReelResponse>();

export const getCachedInstagramReelMedia = async (postCode: string): Promise<InstagramReelResponse> => {
  // Check if we have cached data for this post code
  if (reelCache.has(postCode)) {
    return reelCache.get(postCode)!;
  }

  // If not in cache, fetch from API
  try {
    const data = await fetchInstagramReelMedia(postCode);
    
    // Store in cache for future use
    reelCache.set(postCode, data);
    
    return data;
  } catch (error) {
    console.error(`Error fetching Instagram reel media for post code ${postCode}:`, error);
    throw error;
  }
};